/**
 * Edit contact details
 */
$(document).ready(function() {
    $('#resendInvitationalEmail').click(function() {
        var self = this;
        $(self).addClass('disabled');

        $.ajax({
            url: '/affiliate/SendManualInvitationalEmail/' + $('#TotemForm_EditDetailsForm_OtherID').val(),
            type: 'Post',
            success: function(data) {
                data = JSON.parse(data);
                if (data.success == 0) {
                    alert('Sorry, the email could not be sent.');
                }

                $(self).removeClass('disabled');
                alert('Email sent successfully.\r\n');
            },
            error: function() {
                $(self).removeClass('disabled');
                alert('An error occurred whilst sending the email, please try again.');
            }
        });
    });

    $('#resendInvitationalSMS').click(function() {
        var self = this;
        $(self).addClass('disabled');

        $.ajax({
            url: '/affiliate/SendManualInvitationalSMS/' + $('#TotemForm_EditDetailsForm_OtherID').val(),
            type: 'Post',
            success: function(data) {
                data = JSON.parse(data);
                if (data.success == 0) {
                    alert('Sorry, the SMS cannot be sent.\r\n' + data.message);
                } else {
                    alert('SMS sent successfully.\r\n');
                }
                $(self).removeClass('disabled');
            },
            error: function() {
                $(self).removeClass('disabled');
                alert('An error occurred whilst sending the SMS, please try again.');
            }
        });
    });

    $('#TotemForm_EditDetailsForm_Commission').on('change', function() {
        commissionChangeLogic('TotemForm_EditDetailsForm');
    });

    $('#TotemForm_EditDetailsForm_CommissionType').on('change', function() {
        if ($(this).val() == '*') {
            jQuery('#MaxCommissionMatch').show();
        } else {
            jQuery('#MaxCommissionMatch').hide();
        }

        commissionChangeLogic('TotemForm_EditDetailsForm');
    });

    $('#TotemForm_EditDetailsForm_CountryGeoIDAffiliate').change(function() {
        var val = this.value;
        $.ajax({
            url: '/affiliate/statesjson',
            data: {
                country: val
            },
            type: 'GET',
            success: function(data) {
                var responseJSON = jQuery.parseJSON(data);
                $('#TotemForm_EditDetailsForm_StateGeoIDAffiliate').html(responseJSON.html);
            },
            error: function(data) {}
        });
    });

    if (typeof ChildTotemAffiliatesDS !== 'undefined') {
        $('#child-affiliates-grid').kendoGrid({
            selectable: false, //'multiple,row',
            pageable: {
                pageSize: 10
            },
            columns: [
                {
                    field: 'Title',
                    title: 'Title',
                    width: '150px'
                },
                {
                    field: 'Type',
                    title: 'Type',
                    width: '100px'
                },
                {
                    field: 'AffiliateParentTitle',
                    title: 'Parent Affiliate',
                    width: '200px'
                },
                {
                    field: 'CalculateBaseCommission',
                    title: 'Rewards',
                    width: '100px'
                },
                // {
                //     field: "CalculateChildMaxBaseCommission",
                //     title: "Commission down"
                // },
                {
                    filterable: false,
                    title: '',
                    width: '125px',
                    template:
                        '<a href="/affiliate/editdetails/${TotemAffiliateStaffID}/${ID}/0" id="edit-affiliate-${ ID }" data-record-id="${ ID }" class="btn small primary edit-btn">Edit</a>'
                }
            ],
            dataSource: ChildTotemAffiliatesDS
        });
    }

    if (typeof TotemAffiliateStaffDS !== 'undefined') {
        $('#staff-affiliates-grid').kendoGrid({
            selectable: false, //'multiple,row',
            columns: [
                {
                    field: 'Surname',
                    title: 'Surname'
                },
                {
                    field: 'FirstName',
                    title: 'First Name'
                },
                {
                    field: 'Email',
                    title: 'Email'
                },
                {
                    filterable: false,
                    title: '',
                    width: '250px',
                    template:
                        '<a href="/affiliate/editdetails/${ID}/0/0" id="edit-affiliate-staff-${ ID }" data-record-id="${ ID }" class="btn small primary edit-btn">Edit</a>'
                }
            ],
            dataSource: TotemAffiliateStaffDS
        });
    }

    if (typeof TotemAffiliateCustomersDS !== 'undefined') {
        $('#customers-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                {
                    field: 'FirstName',
                    title: 'First Name',
                    width: '125px'
                },
                {
                    field: 'Surname',
                    title: 'Surname',
                    width: '125px'
                },
                {
                    field: 'Email',
                    title: 'Email',
                    width: '125px'
                },
                {
                    field: 'Mobile',
                    title: 'Phone',
                    width: '125px'
                },
                {
                    field: 'LeadProgress',
                    title: 'Status',
                    width: '550px',
                    template:
                        '<ul class="status-list # if(data.LeadProgress == "paid") { # complete # } #" data-status="#= data.LeadProgress #"><li class="new # if(data.LeadProgress == "new") { # active # } #"><span>New</span></li>' +
                        '<li class="appointment # if(data.LeadProgress == "appointment") { # active # } #"><span>Appointment</span></li>' +
                        '<li class="contract-signed # if(data.LeadProgress == "contract-signed") { # active # } #"><span>Contract Signed</span></li><li class="payable # if(data.LeadProgress == "payable") { # active # } #">' +
                        '<span>Payable</span></li><li class="paid # if(data.LeadProgress == "paid") { # active # } #"><span>Paid</span></li></ul>'
                },
                {
                    filterable: false,
                    title: '',
                    width: '100px',
                    template:
                        '<a href="/affiliate/editcustomer/${ID}" id="edit-customer-${ ID }" data-record-id="${ ID }" class="edit-btn">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.5 21l-6.5 2 2-6.5 12-12 4.5 4.5zM15 4.5l3.086-3.085c.' +
                        '778-.778 2.05-.778 2.828 0l1.672 1.671c.778.779.778 2.051 0 2.829l-3.086 3.085M17.25 6.75l-10.75 10.75M3 16.5l1 1h2.5v2.5l1 1M2 20l2 2M16.5 3l4.5 4.5" ' +
                        'stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></svg></a>'
                }
            ],
            dataSource: TotemAffiliateCustomersDS,
            pageable: {
                pageSize: 10
            }
        });
    }
});

function commissionChangeLogic(formName) {
    $('#' + formName + '_CommissionAmtDown').val('LOADING....');
    $('#' + formName + '_CommissionAmtUp').val('LOADING....');
    $.ajax({
        url: '/affiliate/getCalculatedChildMaxBaseCommission',
        data: {
            affiliateID: $('#' + formName + '_AffiliateBeingEditedID').val(),
            commission: $('#' + formName + '_Commission').val()
        },
        type: 'GET',
        success: function(data) {
            var baseEle = $('#' + formName + '_CommissionAmt');
            var childBase = data;
            if (baseEle.length) {
                var base = baseEle.val().replace('$', '');
                var childIncome = parseFloat(base) - parseFloat(childBase);
                if (isNaN(childIncome) || childIncome <= 0) {
                    childIncome = 'N/A';
                }
                $('#' + formName + '_CommissionAmtUp').val('$' + childIncome);
            }
            $('#' + formName + '_CommissionAmtDown').val('$' + childBase);
        }
    });
}
